<div class="search-container">
    <div class="flex">
      <div class="mt-[60px]">
        <div class="search-by-product">
          <h2>如您知悉博世号或原厂信息可快速搜索</h2>
        </div>
  
        <div class="product-input-container">
          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" nz-input [(ngModel)]="searchContent" placeholder="请输入博世号/原厂信息"
            (keydown.enter)="onHandleSearch()">
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <i class="search-icon" nz-icon nzType="search" (click)="onHandleSearch()"></i>
          </ng-template>
        </div>
      </div>
      <img style="margin-left: 20px; height: 190px;" src="assets/official-website/people-vehicle.png">
    </div>
    <!-- <app-vin-parts-search  [activeTabIndex]="1" [productList]="productList" (dataEvent)="showResult=false" *ngIf="showResult" (viewDetail)="onViewDetail($event)"></app-vin-parts-search> -->
  </div>
